// extracted by mini-css-extract-plugin
module.exports = {"submission_selector":"Recap_submission_selector_2mq3O","selected":"Recap_selected_1Ov4T","mobile_margin":"Recap_mobile_margin_3BgiA","mobile_padding":"Recap_mobile_padding_1FbZ8"};